export default __webpack_public_path__ + "static/two-ladies-85ac64ac978ff26e80963de271dc9d90.jpg";